import { History } from 'history';
import queryString from 'query-string';

export function stringifyQuery(
    history: History,
    params: Record<string, number>
) {
    return queryString.stringify({
        ...queryString.parse(history.location.search.slice(1)),
        ...params
    });
}
